<template>
  <b-pagination
    v-bind="$attrs"
    @input="onPaginate"
    :per-page="pagination.page_size"
    :value="pagination.page"
    align="center"
    class="global-umr-list__pagination m-0"
  ></b-pagination>
</template>

<script>
import { defineComponent, inject } from '@vue/composition-api'

export default defineComponent({
  name: 'BDXStatusModalPagination',
  emits: ['paginate'],
  setup() {
    const { pagination, setPagination } = inject('global-umr-modal')

    const onPaginate = (page) => {
      setPagination({
        ...pagination.value,
        page
      })
    }

    return {
      pagination,

      onPaginate
    }
  }
})
</script>

<style>
.global-umr-list__pagination .page-link {
  width: 30px;
  height: 30px;
  border: 0;
  font-size: 14px;
}
</style>
